import { environment } from 'src/environments/environment';

const csAppBase = environment.digitalApi;

const API_END_POINTS = {
  PROJECT_SCHEDULE_STATS: `${environment.apimNcVersion}/projects-chedule/stats`,
  MATERIAL_PLAN_STATS: `${environment.apimNcVersion}/material-planning/stats`,
  LAST_REFRESHED_DATE: `${environment.apimNcVersion}/last-refreshed-date`,
  CONSTR_MGMT_STATS: `${environment.apimNcVersion}/construction-management/stats`,
  HSE_STATS: `${environment.apimNcVersion}/hse/stats`,
  HSE_DETAILS: `${environment.apimNcVersion}/hse/details`,
  IVDIMAGES: `${environment.apimNcVersion}/files/4dimages`,
  HSE_INDICATORS: `${environment.apimNcVersion}/health-safety/indicators`,
  HSE_TOP_RIBBON_DATA: `${environment.apimNcVersion}/health-safety/topribbondata`,
  VDR_STATS: `${environment.apimNcVersion}/vdr/stats`,
  AREA_STATUS: `${environment.apimNcVersion}/project-scheduling/location-sch`,
  AREA_TASK_STATUS: `${environment.apimNcVersion}/project-scheduling/task-sch`,
  PROJECT_SCHEDULE_EQUIPMENT_TAG: `${environment.apimNcVersion}/project-scheduling/equipment-tag`,
  AREA_ALERTS: `${environment.apimNcVersion}/areaalerts`,
  DOCUMENT_CONTROL_STATS: `${environment.apimNcVersion}/document-control/stats`,
  DOCUMENT_SCURVE: (projectId: string) =>
    `${environment.apimNcVersion}/document-control/scurve?ProjectId=${projectId}`,
  PROJECT_SCHEDULE_CHARTDATA: (projectId: string) =>
    `${environment.apimNcVersion}/project-scheduling/curve-chart?ProjectId=${projectId}`,
  PROJECT_SCHEDULE_MONTH_RANGE: `${environment.apimNcVersion}/project-scheduling/date-range`,
  PROJECT_SCHEDULE_ALERTS: `${environment.apimNcVersion}/project-scheduling/alerts`,
  PROJECT_SCHEDULE_TABLEDATA: `${environment.apimNcVersion}/project-scheduling/details`,
  PROCUREMENT_S_CURVE_LINE_CHARTDATA: (projectId: string) =>
    `${environment.apimNcVersion}/expediting-report/overallscurve?ProjectId=${projectId}`,
  DISCIPLINE_S_CURVE_CHARTDATA: `${environment.apimNcVersion}/expediting-report/disciplinescurve`,
  EXPEDITING_MATERIAL_DELIVERED_STATUS_PIE_CHARTDATA: `${environment.apimNcVersion}/materialdeliveredstatus/piechartdata`,
  EXPEDITING_UPCOMING_MATERIAL_DELIVERY_STATUS_PIE_CHARTDATA: `${environment.apimNcVersion}/upcomingdeliverystatus/piechartdata`,
  EXPEDITING_REPORT_TABLEDATA: `${environment.apimNcVersion}/expeditingreport/tabledata`,
  DATA_QUALITY: `${environment.apimNcVersion}/home-page/data-quality`,
  HIGHLIGHTS_CONCERNS: `${environment.apimNcVersion}/project-highlights`,
  UPDATE_HIGHLIGHTS_CONCERNS: `${environment.apimNcVersion}/project-highlights/UpdateForm`,
  GET_HIGHLIGHTS_CONCERNS: `${environment.apimNcVersion}/project-highlights/GetFormById?FormId=`,
  DASHBOARD_LINK: (pageName: string) =>
    `${environment.apimNcVersion}/DashboardPageLink${pageName}`,
  HIGHLIGHTS_CONCERNS_ALL: `${environment.apimNcVersion}/project-highlights/all`,
  STACKED_COL_DATA: `${environment.apimNcVersion}/stacked-col-data`,
  DELIVERY_STATUS: `${environment.apimNcVersion}/delivery-status`,
  DRILLDOWN_DATA: `${environment.apimNcVersion}/drill-down-data`,
  MATERIAL_DELAY_REASON: `${environment.apimNcVersion}/material-delay-reason`,
  MATERIAL_DELIVERY_STATUS: `${environment.apimNcVersion}/material-planning/delivery-status`,
  MATERIAL_DELAY_DRILLDOWN: `${environment.apimNcVersion}/material-delay-drilldown`,
  MATERIAL_RELEASE_STATUS: (projectId: string) =>
    `${environment.apimNcVersion}/material-planning/release-status?ProjectId=${projectId}`,
  MATERIAL_ACTUAL_STATUS: (projectId: string) =>
    `${environment.apimNcVersion}/material-planning/actual-status?ProjectId=${projectId}`,
  INIT_USER: `${environment.apimNcVersion}/users/init`,
  HOME_CARD_DATA: (projectId: string, areas: string) =>
    `${environment.apimNcVersion}/home-page/widgets?projectId=${projectId}&area=${areas}`,
  DELAY_FORM: `${environment.apimNcVersion}/delay-form`,
  GET_DELAY_TABLE: `${environment.apimNcVersion}/delay-form/status-formdata`,
  GET_FORM_DATA_BY_ID: (uId: string) =>
    `${environment.apimNcVersion}/delay-form/${uId}`,
  GET_NEW_AVAILABLE_PROJECTS: `${environment.apimNcVersion}/master-data/temporary-npis-projects`,
  GET_ASSIGNED_PROJECT_NAMES: `${environment.apimNcVersion}/projects`,
  GET_ALL_PROJECTS: `${environment.apimNcVersion}/projects/all-projects`,
  GET_PROJECT_BY_PROJECTID: (projectCode: string) =>
    `${environment.apimNcVersion}/projects/${projectCode}`,
  FETCH_PROJECT_DETAILS: (uId: string) =>
    `${environment.apimNcVersion}/projects/${uId}`,
  DELAY_REASONS: `${environment.apimNcVersion}/delay-reasons`,
  GET_AREAS: (projectId: string) =>
    `${environment.apimNcVersion}/areas/${projectId}`,
  DOC_CONTROL_FILTERS: (pojectId: string) =>
    `${environment.apimNcVersion}/document-control/filters?ProjectId=${pojectId}`,
  DOCUMENT_FORM_TITLES: `${environment.apimNcVersion}/document-control/document-titles`,
  DOCUMENT_FORM_NUMBER_VERSION: `${environment.apimNcVersion}/document-control/document-number`,
  DOCUMENT_FORM_DETAILS: `${environment.apimNcVersion}/document-control/document-details`,
  DOCUMENT_CONTROL_IFC_PERCENT: `${environment.apimNcVersion}/document-control/ifc-percent`,
  DOCUMENT_CONTROL_DELIVERY_TABLE: `${environment.apimNcVersion}/document-control/deliverable-status`,
  SAVE_DOCUMENT_CONTROL_FORM: `${environment.apimNcVersion}/document-control/save-form`,
  DOC_NOT_ISS_DISC: `${environment.apimNcVersion}/document-control/not-issued-by-discipline`,
  DOC_RELEASE_PLAN: `${environment.apimNcVersion}/document-control/release-plan`,
  DOC_DEL_BY_DISC: `${environment.apimNcVersion}/document-control/deliverables-by-discipline`,
  DOC_IFC: `${environment.apimNcVersion}/document-control/issued-after-ifc`,
  USERS: `${environment.apimNcVersion}/users`,
  CWP: `${environment.apimNcVersion}/cwp`,
  CONTRACTORS: `${environment.apimNcVersion}/contractors`,
  PO_LEVEL_DETAILS: (po: string, projectId: string) =>
    `${environment.apimNcVersion}/commodity-tracking/${po}?ProjectId=${projectId}`,
  COMMODITY_TRACKING_SAVE: `${environment.apimNcVersion}/commodity-tracking/`,
  COMMODITY_DATA: `${environment.apimNcVersion}/commodity-tracking/all`,
  FILES: `${environment.apimNcVersion}/files`,
  SAVE_SITEMAP: `${environment.apimNcVersion}/sitemap`,
  GET_SITEMAP: (projectId: string) =>
    `${environment.apimNcVersion}/sitemap/${projectId}`,
  EXECUTION_DELAY_STATUS: `${environment.apimNcVersion}/delay-form/execution-delay-status`,
  EXECUTION_DELAY_HOURS: `${environment.apimNcVersion}/delay-form/execution-delay-hours`,
  IMPACT_ASSESSMENT: `${environment.apimNcVersion}/impact-areas`,
  VDR_RECEIPT_STATUS: `${environment.apimNcVersion}/vdr/status`,
  VDR_CRITICAL_DOCUMENTS: `${environment.apimNcVersion}/vdr/criticaldocuments`,
  MATERIAL_PLANNING_FILTERS: (projectId: string) =>
    `${environment.apimNcVersion}/material-planning/filters?ProjectId=${projectId}`,
  MATERIAL_PLANNING_DELAY_REASON: `${environment.apimNcVersion}/material-planning/material-delay-reason`,
  VDR_CRITICAL_DOCUMENT_STATUS: `${environment.apimNcVersion}/vdr/critical-document-status`,
  VDR_REVIEW_STATUS: `${environment.apimNcVersion}/vdr/received-reviewed`,
  VDR_FILTERS: `${environment.apimNcVersion}/vdr/filters`,
  EXPEDITING_S_CURVE_FILTERS: (projectId: string) =>
    `${environment.apimNcVersion}/expediting-report/filters?ProjectId=${projectId}`,
  COMMODITY_OVERALL_STATUS: `${environment.apimNcVersion}/commodity-tracking/overall-status`,
  MASTER_DATA: `${environment.apimNcVersion}/master-data`,
  ABBREVIATION: `${environment.apimNcVersion}/master-data/abbreviation-data`,
  REFRESH_DATA: (projectId: string) =>
    `${environment.apimNcVersion}/master-data/refresh-data?ProjectId=${projectId}`,
  CONSTRUCTION_MANAGEMENT: `${environment.apimNcVersion}/construction-management`,
  CONSTRUCTION_MANAGEMENT_MONTH_RANGE: `${environment.apimNcVersion}/construction-management/date-range`,
  CONSTRUCTION_MANAGEMENT_CRAFTS: (projectId: string) =>
    `${environment.apimNcVersion}/construction-management/crafts?ProjectId=${projectId}`,
  FILES_REPORTS: `${environment.apimNcVersion}/files/reports`,
  MODEL_3D_SECRETS: `${environment.apimNcVersion}/model3d-secrets`,
  DROP_DOWN_VALS: `${environment.apimNcVersion}/common/dropdownvalues`,
  OVERALL_SCURVE: (projectId: string) =>
    `${environment.apimNcVersion}/common/overall-scurve?ProjectId=${projectId}`,
  AI_ASSIST_CATEGORY: `/ai/lookups/categories`,
  AI_ASSIST_SESSION_WITH_CATEGORY: (category: string) =>
    `/ai/chats?category=${category}`,
  AI_ASSIST_CHAT_SESSION_ID: (sessionId: string) => `/ai/chats/${sessionId}`,
  AI_ASSIST_CHATS_DATA: (sessionId: string) => `/ai/chats/${sessionId}`,
  AI_ASSIST_ALL_CHATS: `/ai/chats`,
  ADMIN_HOME_PAGE: `${environment.apimNcVersion}/home-page/update-widget-flags`,
  EXCEL_DOWNLOAD_4D: `${environment.apimNcVersion}/files/4dimage-file`,
  HIGHLIGHT_CONCERN_HISTORY: `${environment.apimNcVersion}/project-highlights/GetHistoryByIdAsync`,
  LOG_ACTIVITY: `${environment.apimNcVersion}/Logs/AddLogs`,
  FETCH_LOGS: `${environment.apimNcVersion}/Logs`,
  ADDRESS_BOOK_SEARCH: `${environment.csappsVersion}/email/suggestions`,
  INVITED_USERS: ` ${environment.csappsVersion}/invited_users?product_id=${environment.productId}&page=1&perpage=20&sortorder=asc&sort_by=Added%20On&customer_id=21&keyword=`,
  INVITE_USER: `/csapps-usermgt/v1/csapps-common-ms/invite?product_id=${environment.productId}&customer_id=21`,
  SAS_URL: `${environment.apimNcVersion}/files/get-sas`,
  GET_TABS: (projectID: string | undefined) =>
    `${environment.apimNcVersion}/wizard/get-tabs/${projectID}`,
  SAVE_WIZARD_STEP: `${environment.apimNcVersion}/wizard`,
  GET_WIZARD_STEP: (projectId: string) =>
    `${environment.apimNcVersion}/wizard/${projectId}`,
  GET_PROJECT_NAMES: `${environment.apimNcVersion}/projects`,
  SAVE_4D_FILES: `${environment.apimNcVersion}/files/save-archive-data`,
  FETCH_4D_FILES: `${environment.apimNcVersion}/files/uploaded-data`,
  FETCH_PROJECT_AREAS: `${environment.apimNcVersion}/project-mapping/project-area`,
  FETCH_SYNAPSE_TOKEN: `${environment.apimNcVersion}/token/synapse`,
  FETCH_DATA_SOURCES: `${environment.apimNcVersion}/data-source`,
  FETCH_DATA_SOURCE_COLUMNS: `${environment.apimNcVersion}/data-source/data-source-columns`,
  FETCH_DATA_SOURCE_PROJ_MAPPING: `${environment.apimNcVersion}/data-source/data-source-mapping`,
  SEND_ONBOARDING_EMAIL: (projectId: string) =>
    `${environment.apimNcVersion}/email/send-support-ad-group-notification/${projectId}`,
  SAVE_DATA_SOURCE_MAPPINGS: `${environment.apimNcVersion}/data-source`,
  FETCH_MANUAL_UPLOAD_MODULES: (projectId: string) =>
    `${environment.apimNcVersion}/manual-upload/${projectId}`,
  FETCH_LATEST_FILE_RECORD: `${environment.apimNcVersion}/manual-upload/latest-manual-file-upload`,
  SAVE_MANUAL_FILE_UPLOAD: `${environment.apimNcVersion}/manual-upload`,
  GET_ROLES: `/csapps-appmgt/v1/csapps-common-ms/group_role_assignment?product_id=${environment.productId}`,
  GET_ALL_DASHBOARDS_LIST: `${environment.apimNcVersion}/dashboard-mapping`,
  UPDATE_DASHBOARDS_LIST: `${environment.apimNcVersion}/dashboard-mapping/dashboard-link`,
  GET_ALL_DASHBOARDS_LIST_BY_PROJECTID: (projectId: string) =>
    `${environment.apimNcVersion}/dashboard-mapping?projectId=${projectId}`,
  UPDATE_ACTIVE_DASHBOARD_LIST: `${environment.apimNcVersion}/dashboard-mapping/project-dashboard`,
  FETCH_REGIONS: `${environment.apimNcVersion}/master-data/regions`,
  FETCH_OPERATING_UNITS: `${environment.apimNcVersion}/master-data/operating-units`,
  SAVE_PROJECT_DETAILS: `${environment.apimNcVersion}/projects`,
  FETCH_SYSTEM_IDS: `${environment.apimNcVersion}/data-source/system-ids`,
  FETCH_PROJECT_DATA_SOURCE: `${environment.apimNcVersion}/data-source/project-datasource`,
  FETCH_CUSTOMER_NAME: `${environment.apimNcVersion}/master-data/customers`,
  GET_ALL_KPIS: (projectId: string) =>
    `${environment.apimNcVersion}/home-page/kpis?projectId=${projectId}`,
  UPDATE_ALL_KPIS: `${environment.apimNcVersion}/home-page`,

  FORMS: {
    FETCH_BY_PROJECT_ID: (projectId: string) =>
      `${environment.apimNcVersion}/form/project/${projectId}`,
    SAVE_FORM: `${environment.apimNcVersion}/form`,
    FETCH_ALL_FORMS: `${environment.apimNcVersion}/form`,
    FETCH_BY_ID: (formId: string) =>
      `${environment.apimNcVersion}/form/${formId}`,
    FETCH_DYNAMIC_DROPDOWN_KEYS: `${environment.apimNcVersion}/master-data/config-keys/dropdown-dynamic`,
    FETCH_DYNAMIC_DROPDOWN_VAL: `${environment.apimNcVersion}/master-data/config-value`,
    SAVE_FORM_RESPONSE: `${environment.apimNcVersion}/form/response`,
    FETCH_RESPONSE_DETAILS: (responseId: string) =>
      `${environment.apimNcVersion}/form/response/${responseId}`,
    FETCH_FORM_RESPONSES: `${environment.apimNcVersion}/form/response-list`,
    STANDARD_FORM_TYPES: `${environment.apimNcVersion}/form/form-types`,
    STANDARD_FORM_TYPE_MAPPINGS: (projectId: string) =>
      `${environment.apimNcVersion}/form/form-type-mappings?projectId=${projectId}`,
    SAVE_FORM_TYPE_MAPPINGS: `${environment.apimNcVersion}/form/form-type-mappings`,
  },
  WORKFLOWS: {
    FETCH_WF_SKELETON_BY_FORMID: (formId: string) =>
      `${environment.apimNcVersion}/workflow/getWorkflowByForm/${formId}`,
    FETCH_WF_LOGS_BY_RESPONSEID: (responseId: string) =>
      `${environment.apimNcVersion}/workflow/getFormWorkflowDetails?formResposnseId=${responseId}`,
    SAVE_WF_SKELETON: `${environment.apimNcVersion}/workflow`,
  },
  SAVE_REPORTS_DATA: `${environment.apimNcVersion}/projects/reports`,
  GET_REPORTS: (projectId: string) =>
    `${environment.apimNcVersion}/projects/reports/${projectId}`,
  ASSIGNED_ROLES_TO_USER: (userId: string) =>
    `${environment.csappsAppmgtVersion}/product/${environment.productId}/user_roles?customer_id=21&user_id=${userId}`,
  NOTIFICATIONS: {
    FETCH: `${environment.apimNcVersion}/notification`,
    FETCH_MASTER: `${environment.apimNcVersion}/notification/master`,
    NOTIFY: `${environment.apimNcVersion}/notification/add-multiple`,
    MARK_READ: (notificationId: string) =>
      `${environment.apimNcVersion}/notification/read/${notificationId}`,
  },
  USER: {
    FETCH_CURRENT: `${environment.apimNcVersion}/users/current-user`,
  },
  PROJECT: {
    ACTIVATE_PROJECT: `${environment.apimNcVersion}/projects/set-is-active`,
  },
  KPI_ALERTS: {
    ALERT_CONFIG: `${environment.apimNcVersion}/Alerts/alert-config`,
    FETCH_ALERT_THRESHOLD_DATA: `${environment.apimNcVersion}/Alerts/alert-column-mapping`,
  },
  FAQS: {
    FETCH_ALL_FAQ: `${environment.apimNcVersion}/faq`,
  },

  S3: {
    UPLOAD_TO_S3: `${environment.apimNcVersion}/S3/upload`,
    GENERATE_PRESIGNED_URL:`${environment.apimNcVersion}/S3/createPreSignedUrl`,
  },
};

export default API_END_POINTS;
